var defaultExport={}

defaultExport.gbTranslation = {
    "dynamic" : {
      "Account" : "Account",
      "AdMob" : "AdMob",
      "Add_section" : "Add section",
      "App_Preview" : "App Preview",
      "App_Setup" : "App Setup",
      "App_Submit" : "App Submit",
      "App_id" : "App id",
      "App_images" : "App images",
      "App_info" : "App info",
      "App_name" : "App name",
      "App_sections" : "App sections",
      "App_settings" : "App settings",
      "App_setup" : "App setup",
      "Basic" : "Basic",
      "Billing" : "Billing",
      "Cancel" : "Cancel",
      "Cancel_creating_app" : "Cancel creating app",
      "Close" : "Close",
      "Confirm" : "Confirm",
      "Create" : "Create",
      "Create_app" : "Create app",
      "Current_plan" : "Current plan",
      "Dashboard" : "Dashboard",
      "Delete" : "Delete",
      "Delete_App" : "Delete App",
      "Design" : "Design",
      "Full_Name" : "Full Name",
      "General" : "General",
      "Hello" : "Hello",
      "Images" : "Images",
      "Layout" : "Layout",
      "List_design" : "List design",
      "Loading" : "Loading",
      "Login" : "Login",
      "Logout" : "Logout",
      "MASTER_DETAILS_VIEWS" : "MASTER DETAILS VIEWS",
      "Manage" : "Manage",
      "Manage_app" : "Manage app",
      "My_Profile" : "My Profile",
      "Navigation_bar" : "Navigation bar",
      "New_app" : "New app",
      "Orders" : "Orders",
      "Overview" : "Overview",
      "Package_id" : "Package id",
      "PayPal" : "PayPal",
      "Preview" : "Preview",
      "Preview_your_app" : "Preview your app",
      "Purchase_now" : "Purchase now",
      "Push_notification" : "Push Notification",
      "Reset_Password" : "Reset Password",
      "SPECIFIC_VIEWS" : "SPECIFIC VIEWS",
      "Save_changes" : "Save changes",
      "Search_apps" : "Search apps",
      "Section_name" : "Section name",
      "Sections" : "Sections",
      "Settings" : "Settings",
      "Side" : "Side",
      "Submit" : "Submit",
      "Submit_app" : "Submit app",
      "Submit_you_app" : "Submit your app",
      "Sude_menu_colors" : "Sude menu colors",
      "Switch" : "Switch",
      "Tabs" : "Tabs",
      "Template" : "Template",
      "Translations" : "Translations",
      "Use_this_layout" : "Use this layout",
      "Use_this_template" : "Use this template",
      "User_Info" : "User Info",
      "User_profile" : "User profile",
      "Users" : "Users",
      "Visit" : "Visit",
      "preview_app" : "preview app",
      "rab_id" : "rab_id",
      "required" : "required"
    },
    "static" : {
      "All_data_at_this_location_incuding_nested_sections_will_be_deleted" : "All data at this location incuding nested sections will be deleted",
      "All_informations_are_required" : "All informations are required",
      "And_preview_you_app" : "And Preview Your App",
      "And_preview_your_app" : "And preview your app",
      "App_name_missing" : "App name missing",
      "App_package_id_missing" : "App package id missing",
      "Cancel_Subscription" : "Cancel Subscription",
      "Confirm_selected_and_entered_data" : "Confirm selected and entered data",
      "Creat_new_Admin_project" : "Create new Admin project",
      "Create_app_from_template" : "Create app from template",
      "Create_new_translation" : "Create new translation",
      "Delete_section" : "Delete section",
      "Drag_n_Drop_them_Also_you_can_nest_them" : "Drag n Drop them Also you can nest them",
      "Features" : "Features",
      "Go_Back" : "Go Back",
      "Icon_Splash_Logo" : "Icon Splash Logo",
      "Just_add_the_section_you_like" : "Just add the section you like",
      "Just_scan_the_QR_code" : "Just scan the QR code",
      "Let's_make_an_app" : "Let's make an app",
      "Make_translation" : "Make translation",
      "Manage_translation" : "Manage translation",
      "Message_body" : "Message body",
      "Message_text" : "Message text",
      "Message_title" : "Message title",
      "Name_PackageId_AppId" : "Name PackageId AppId",
      "New_Password" : "New Password",
      "New_Password_Confirmation" : "New Password Confirmation",
      "New_Translation" : "New Translation",
      "New_admin" : "New admin",
      "Our_automated_script" : "Our automated script",
      "Plan_Features" : "Plan Features",
      "Please_Purchase_now" : "Please Purchase now",
      "Please_update_your_Item_Purchase_Code" : "Please update your Item Purchase Code",
      "Please_update_your_Subscription_Plan" : "Please update your Subscription Plan",
      "Please_write_delete_to_confirm_deleting_the_app" : "Please write delete to confirm deleting the app",
      "Scan_the_qr_code_with_this" : "Scan the qr code with this",
      "Select_Traslation_To_Start_From" : "Select Traslation To Start From",
      "Select_the_app_layout" : "Select the app layout",
      "Select_the_app_type" : "Select the app type",
      "Send_push_notification_with" : "Send push notification with",
      "Subscription" : "Subscription",
      "Subscription_Options" : "Subscription Options",
      "Update_Billing_Info" : "Update Billing Info",
      "Use_Master_Detail_or_some_specific_one" : "Use Master Detail or some specific one",
      "What_kind_of_app_you_will_make?" : "What kind of app you will make?",
      "You_don't_have_Item_Purchase_Code_or_your_Item_Purchase_Code_is_not_valid" : "You don't have Item Purchase Code or your Item Purchase Code is not valid",
      "You_don't_have_any_Subscription_Plan" : "You don't have any Subscription Plan",
      "You_have_reach_the_limit_for_maximum_apps" : "You have reach the limit for maximum apps",
      "rab_saas_site" : "Settings",
      "will_send_you_an_email_when_your_apps_are_made" : "will send you an email when your apps are made"
    }
  }
  
  export default defaultExport;


// WEBPACK FOOTER //
// ./src/config/gb_translation.js